function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import PropTypes from "prop-types";
import React from "react";
import classNames from "classnames";

var Icon = /*#__PURE__*/function (_React$Component) {
  _inherits(Icon, _React$Component);

  var _super = _createSuper(Icon);

  function Icon() {
    _classCallCheck(this, Icon);

    return _super.apply(this, arguments);
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this = this;

      var rotation, size;

      var style = _objectSpread({
        marginRight: this.props.isBeforeText ? 8 : undefined,
        marginLeft: this.props.isAfterText ? 8 : undefined
      }, this.props.style);

      if (this.props.rotate) {
        rotation = "".concat(this.props.iconKit, "-icon-rotate-").concat(this.props.rotate);
      }

      if (this.props.size > 1) {
        size = "".concat(this.props.iconKit, "-icon-").concat(this.props.size, "x");
      } else if (this.props.size === 1) {
        size = "".concat(this.props.iconKit, "-icon-lg");
      }

      return /*#__PURE__*/React.createElement("i", {
        role: "img",
        "aria-label": this.props.title || "icon: ".concat(this.props.icon),
        style: style,
        onClick: !this.props.disabled ? this.props.onClick : undefined,
        onKeyUp: function onKeyUp(_ref) {
          var key = _ref.key;
          if (key === "Enter" && typeof _this.props.onKeyUp === "function") _this.props.onKeyUp();
        },
        tabIndex: this.props.isReachable ? 0 : -1,
        "data-tour-id": this.props["data-tour-id"] || "",
        className: classNames("".concat(this.props.iconKit, "-icon ").concat(this.props.iconKit, "-icon-").concat(this.props.icon), this.props.className, rotation, size, {
          "is-disabled": this.props.disabled,
          "gt-icon-fw": this.props.fixed,
          "gt-icon-spin": this.props.spin
        }),
        alt: this.props.altText || this.props.icon
      });
    }
  }]);

  return Icon;
}(React.Component);

_defineProperty(Icon, "displayName", "Icon");

_defineProperty(Icon, "propTypes", {
  icon: PropTypes.string.isRequired,
  size: PropTypes.number,
  rotate: PropTypes.number,
  fixed: PropTypes.bool,
  spin: PropTypes.bool,
  disabled: PropTypes.bool,
  isBeforeText: PropTypes.bool,
  isAfterText: PropTypes.bool,
  onClick: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
  isReachable: PropTypes.bool,
  onKeyUp: PropTypes.func,

  /** Boolean: if using in a tooltip disable the title */
  disableTitle: PropTypes.bool,
  iconKit: PropTypes.string,
  altText: PropTypes.string
});

_defineProperty(Icon, "defaultProps", {
  size: 0,
  fixed: true,
  style: {},
  iconKit: "gt"
});

export { Icon as default };